export const RESET = 'EXSBITEMTYPE_UPDATE_RESET'
export const SET_ERROR = 'EXSBITEMTYPE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBITEMTYPE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBITEMTYPE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBITEMTYPE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBITEMTYPE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBITEMTYPE_UPDATE_UPDATE_RETRIEVED'
